export default __webpack_public_path__ + "static/media/no-chargebacks.a02fff57.png";